module.exports = __webpack_public_path__ + "img/充电.ec21195f.png";